module.exports = __webpack_public_path__ + "images/emoji/ox.f638e381b171ba773987.png";